import {
  CustomsOfficeOfExitForTransitDeclared,
} from 'features/declaration/models/schemas/commonConsignmentSchemas'
import { isDeletedWithId } from 'shared/lib/common-util'
import { ErrorResult } from '../../../../shared/models/types'
import { deleteCustomsOfficeOfTransitExit } from '../api/deleteCustomsOfficeOfTransitExit'

function useDeleteCustomsOfficeOfTransitExit() {
  const deleteCustomsOfficesOfTransitExit = async (
    customsOfficesOfTransitExit: CustomsOfficeOfExitForTransitDeclared[],
  ): Promise<{ errors: ErrorResult[] }> => {
    const errors: ErrorResult[] = []
    const customsOfficesOfTransitToBeDeleted = customsOfficesOfTransitExit.filter(isDeletedWithId)
    if (!customsOfficesOfTransitToBeDeleted.length) return { errors }

    const settledDeletePromises = await Promise.allSettled(
      customsOfficesOfTransitToBeDeleted
        .map((customsOffice) => deleteCustomsOfficeOfTransitExit(customsOffice.id as number)),
    )

    for (let i = 0; i < settledDeletePromises.length; i++) {
      const settledDeletePromise = settledDeletePromises[i]
      if (settledDeletePromise.status === 'rejected') {
        const customsOffice = customsOfficesOfTransitToBeDeleted[i]
        errors.push({
          message: `Customs office of transit exit with id ${customsOffice.id} delete failed`, // TODO pass down proper axios error?
        })
      }
    }

    return {
      errors,
    }
  }

  return {
    deleteCustomsOfficesOfTransitExit,
  }
}

export default useDeleteCustomsOfficeOfTransitExit
